define('score_bootstrap/Components/ContentSearch/SearchResultsView',[
    "jquery",
    "knockout",
    "eventManager",
    "moduleLoader",
    "score_bootstrap/Components/ContentSearch/SearchResultsBase",
    "score_bootstrap/Models/Tile",
    "score_bootstrap/Models/Search/PromoTile",
    "imagesLoaded",
    "score_bootstrap/Utils/UrlHelper",
    "matchHeight"

], function (
    $,
    ko,
    eventManager,
    moduleLoader,
    SearchResultsBase,
    Tile,
    PromoTile,
    imagesLoaded,
    urlHelper
) {

    var tileCache = {};

    function SearchResultsView(scope, uniqueId, tilesPerPage, tileName, qvTileName, showEvents, switchToClassicPager, classicPagesToDisplay, showEllipsisInBetween, scrollToPageTop) {
        var promoTiles = $(".score-promo-tile", scope).remove().toArray().map(PromoTile.fromElement).sort(PromoTile.sort),
            showMe = this.show.bind(this),
            quickView;

        this.results = ko.observableArray([]);
        this.currentPage = ko.observable(0);
        this.allPages = ko.observableArray([]);
        this.totalPages = ko.observable(0);
        this.showPager = ko.observable(false);

        Object.defineProperties(this, {
            id: { enumerable: true, value: uniqueId },
            tilesPerPage: { enumerable: true, value: tilesPerPage },
            tileName: { enumerable: true, value: tileName },
            quickViewTileName: { enumerable: true, value: qvTileName },
            scope: { enumerable: false, value: scope },
            $scope: { enumerable: false, value: $(scope) },
            $list: { enumerable: false, value: $(".js-search-results", scope) },
            promoTiles: { enumerable: false, value: promoTiles },
            tiles: {
                get: function () {
                    return $("li", this.$list);
                }
            },
            tilesPerRow: {
                enumerable: false,
                get: function () {
                    return SearchResultsBase.howManyTilesPerRow(this.$list);
                }
            },
            isActive: {
                get:function () {
                    return this.$scope.hasClass("active");
                }
            },
            switchToClassicPager: {enumerable:!1, value: !!switchToClassicPager },
            classicPagesToDisplay: { enumerable: !1, value: classicPagesToDisplay|0 },
            showEllipsisInBetween: { enumerable: !1, value: !!showEllipsisInBetween },
            scrollToPageTop: { enumerable: !1, value: !!scrollToPageTop }
        });

        tileCache[this.id] = {};

        if (showEvents.length) {
            showEvents.forEach(function (ev) {
                eventManager.subscribe(ev, showMe);
            });
        }

        if (this.quickViewTileName) {
            Object.defineProperties(this, {
                quickView: {
                    enumerable: false,
                    get: function () {
                        if (!quickView) {
                            quickView = $(".js-quick-view", scope).data("ccf_module");
                        }
                        return quickView;
                    }
                }
            });
        }

        ko.applyBindings(this, scope);
    }

    SearchResultsView.prototype.reset = function reset() {
        this.$list.empty();
        this.results.removeAll();
        this.allPages.removeAll();
        this.currentPage(0);
    };

    SearchResultsView.prototype.appendTiles = function appendTiles(response, isLoadMore) {
        var newTiles = [], originalQuantity = this.tiles.length, lastRowTiles = [];

        // if the current search result is switched to a classic pager, we should clear results collection 
        // which used to render the result results, so it'll have just current page tiles.
        if (this.switchToClassicPager) {
            this.results.removeAll();
        }

        if (isLoadMore) {
            lastRowTiles = SearchResultsBase.getLastRowTiles(this);
        }

        response.items.forEach(function (item) {
            var tileId = item.id.toString(), tile, cache = tileCache[this.id];

            if (!cache.hasOwnProperty(tileId)) {
                cache[tileId] = { item: item };
            }

            if (!cache[tileId].hasOwnProperty(this.tileName)) {
                cache[tileId][this.tileName] = new Tile(item, this.tileName);
            }

            tile = cache[tileId][this.tileName];
            this.results.push(tile);
            newTiles.push(tile.element());
        }, this);

        // store amount pages for a classic pager
        this.totalPages(response.totalPages);
        this.currentPage(response.page);
        this.allPages.removeAll();
        Array.apply(null, { length: response.totalPages }).map((function (v, i) { this.allPages.push(i); }).bind(this));
        this.showPager(response.totalPages > 1 && this.switchToClassicPager);

        if (!newTiles.length) {
            return [];
        }

        moduleLoader.loadPendingModules(this.$list);
        newTiles = $(newTiles).add(SearchResultsBase.injectPromoTiles(this, originalQuantity));
        $(lastRowTiles).add(newTiles).matchHeight({ byRow: true });

        // Wait to run matchHeight until all the images are loaded since
        // height of images affect the height of the tiles
        imagesLoaded($("img", newTiles), function matchHeightOnNewTiles() {
            $.fn.matchHeight._update();
        });

        if (this.initialResultLoaded && this.scrollToPageTop) {
            this.scrollToTopResults();
        }

        // setup the initial release was loaded
        this.initialResultLoaded = !0;

        // explicitly providing hook to tenants for search rendering
        eventManager.trigger("search-rendered", this.scope, response.page | 0, response.perPage | 0, response.totalItems | 0, this.tileName);

        return newTiles;
    };

    SearchResultsView.prototype.show = function show() {
        $(this).triggerHandler("SearchResultsView.show");
        this.$scope.siblings().removeClass("active in");
        this.$scope.addClass("active in");
    };

    SearchResultsView.prototype.getQuickViewTileByElement = function getQuickViewTileByElement($tile) {
        var tileId = $tile.attr("data-id"), cache = tileCache[this.id][tileId];

        if (!cache.hasOwnProperty(this.quickViewTileName)) {
            cache[this.quickViewTileName] = new Tile(cache.item, this.quickViewTileName);
        }

        return cache[this.quickViewTileName];
    };

    SearchResultsView.prototype.showQuickView = function showQuickView(tile, $activeEl) {
        this.tiles.removeClass("active");
        this.quickView.hide();

        if (!tile) return;

        // Calculate where to insert the quick view
        var index = $activeEl.addClass("active").index(),
            tilesPerRow = this.tilesPerRow,
            totalTiles = this.tiles.length,
            positionInRow,
            quickViewPos,
            mod = totalTiles % tilesPerRow,
            fullRows = Math.floor(totalTiles / tilesPerRow);

        // Prev/Next buttons needs to be adjusted before the quick view li is inserted
        this.quickView.toggleControls(index, this.tiles.length);

        // if the active tile is in the last row and the row is not full, insert the quick view directly after the last tile
        if (mod > 0 && index >= (fullRows * tilesPerRow)) {
            quickViewPos = totalTiles - 1;
        }
            // else insert the quick view after the last tile in the current row
        else {
            positionInRow = (index + 1) % tilesPerRow || tilesPerRow;
            quickViewPos = index + (tilesPerRow - positionInRow);
        }

        $(this.tiles[quickViewPos]).closest("li").after(this.quickView.$scope);
        this.quickView.show(tile, index);
        moduleLoader.loadPendingModules(this.quickView.$body);
        this.tiles.matchHeight({ byRow: true });
    };

    SearchResultsView.prototype.getPages = function getPages() {
        //console.log("classicPagesToDisplay", this.classicPagesToDisplay);
        //console.log('totalPages', this.totalPages());
        if (this.totalPages() <= this.classicPagesToDisplay || this.classicPagesToDisplay <= 0) {
            return this.allPages();
        } else {
            var first = 0,
                ellipsisLimit = 3,
                currentPage = this.currentPage(),
                totalPages = this.totalPages();

            var upperLimit = currentPage + 1;
            if (this.showEllipsisInBetween && totalPages - upperLimit === ellipsisLimit) {
                upperLimit++;
            }

            var downLimit = currentPage - 1;
            if (this.showEllipsisInBetween && currentPage === ellipsisLimit) {
                downLimit--;
            }

            while (upperLimit >= totalPages) {
                upperLimit--;
                if (downLimit > first)
                    downLimit--;
            }

            while (downLimit < first) {
                downLimit++;
                if (upperLimit < totalPages)
                    upperLimit++;
            }

            var pages = [];
            for (var i = downLimit; i <= upperLimit; i++) {
                pages.push(i);
            }

            return ko.observableArray(pages);
        }
    };

    SearchResultsView.prototype.showPage = function showPage(pageNumber) {
        $(this).triggerHandler("SearchResultsView.showPage", pageNumber|0);
    }

    SearchResultsView.prototype.showLeftBoundary = function showLeftBoundary() {
        var leftArr = this.getPages().slice(0, 1);
        return leftArr[0] !== 0 && (!this.showEllipsisInBetween || leftArr[0] !== 1);
    }

    SearchResultsView.prototype.showRightBoundary = function showRightBoundary() {
        var leftArr = this.getPages().slice(-1);
        return leftArr[0] < (this.totalPages() - 1) && (!this.showEllipsisInBetween || leftArr[0] < (this.totalPages() - 2));
    }

    SearchResultsView.prototype.showPrevPage = function showPrevPage() {
        if (this.currentPage() - 1 >= 0) {
            this.showPage(this.currentPage() - 1);
        }
    }

    SearchResultsView.prototype.showNextPage = function showNextPage() {
        if (this.currentPage() + 1 < this.totalPages()) {
            this.showPage(this.currentPage() + 1);
        }
    }

    SearchResultsView.prototype.showFirstPage = function showFirstPage() {
        return this.getPages().slice(0, 1)[0] !== 0;
    }

    SearchResultsView.prototype.showLastPage = function showFirstPage() {
        return this.getPages().slice(-1)[0] < (this.totalPages() - 1);
    }
    SearchResultsView.prototype.showLastButOnePage = function showLastButOnePage() {
        return !this.showFirstPage() && this.getPages().slice(-1)[0] < (this.totalPages() - 3);
    }

    SearchResultsView.prototype.firstPageText = function firstPageText() {
        return "1";
    }

    SearchResultsView.prototype.lastPageText = function lastPageText() {
        return this.totalPages();
    }

    SearchResultsView.prototype.lastButOnePageText = function lastPageText() {
        return this.totalPages() - 1;
    }

    SearchResultsView.init = function initSearchResultsView(args) {
        return new SearchResultsView(
            args.scope,
            args.uniqueId,
            args.TilesPerPage,
            args.TileName,
            args.QuickViewTileName,
            args.ShowActionMessages || [],
            args.SwitchToClassicPager,
            args.ClassicPagerButtonsToDisplay,
            args.ShowPagerEllipsisInBetween,
            args.ScrollToPageTop);
    };

    return SearchResultsView;
});
